export const outPutMixin = {
  data() {
    return {
      isOutputing: false
    };
  },
  created() {},
  methods: {
    // 导出excel
    output(data, tableName, outputName) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryList(this.searchCondition.status,"all")
          .then(res => {
            const list = res.result.records;
            const tHeader = this.$refs[tableName].columns
              .map(o => {
                return o.label !== "序号" && o.label !== "操作" && o.label;
              })
              .filter(o => o);
            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs[tableName].$children
                .map(o => o._props.prop)
                .filter(o => o);
            }
            list.forEach(v => {
              v.salesStateFormat = v.salesState === "open" ? "可售" : "停售";
            });
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              outputName + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(err => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
